<template>
  <div class="settings-container">
    <el-card>
      <div slot="header">
        <span>系统设置</span>
      </div>
      
      <el-form :model="settingsForm" :rules="rules" ref="settingsForm" label-width="120px" v-loading="loading">
        <el-divider content-position="left">密钥设置</el-divider>
        
        <!-- USDT密钥 -->
        <el-form-item label="USDT密钥" prop="usdt">
          <el-input 
            v-model="settingsForm.usdt" 
            placeholder="请输入USDT密钥"
            type="password"
            show-password>
          </el-input>
        </el-form-item>
        
        <!-- ERC密钥 -->
        <el-form-item label="ERC密钥" prop="erc">
          <el-input 
            v-model="settingsForm.erc" 
            placeholder="请输入ERC密钥"
            type="password"
            show-password>
          </el-input>
        </el-form-item>
        
        <!-- TokenPay密钥 -->
        <el-form-item label="TokenPay密钥" prop="tokenPaySecret">
          <el-input 
            v-model="settingsForm.tokenPaySecret" 
            placeholder="请输入TokenPay密钥"
            type="password"
            show-password>
          </el-input>
        </el-form-item>
        
        <el-divider content-position="left">服务配置</el-divider>
        
        <!-- TokenPay服务地址 -->
        <el-form-item label="TokenPay服务地址" >
          <el-input 
            v-model="settingsForm.tokenPayService" 
            placeholder="请输入TokenPay服务地址">
          </el-input>
        </el-form-item>
        
        <!-- 回调地址 -->
        <el-form-item label="回调地址" >
          <el-input 
            v-model="settingsForm.notifyUrl" 
            placeholder="请输入支付成功后的回调地址">
          </el-input>
        </el-form-item>
        
        <el-divider content-position="left">联系方式设置</el-divider>
        
        <!-- 客服联系方式 -->
        <el-form-item label="客服联系方式" prop="telegram">
          <el-input 
            v-model="settingsForm.telegram" 
            placeholder="请输入客服联系方式">
          </el-input>
        </el-form-item>
        
        <!-- 邮箱联系方式 -->
        <el-form-item label="邮箱联系方式" prop="email">
          <el-input 
            v-model="settingsForm.email" 
            placeholder="请输入邮箱联系方式">
          </el-input>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="saveSettings" :loading="saveLoading">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Settings',
  data() {
    // 邮箱验证规则
    const validateEmail = (rule, value, callback) => {
      if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('请输入正确的邮箱格式'))
      } else {
        callback()
      }
    }
    
    // URL验证规则
    const validateUrl = (rule, value, callback) => {
      if (value && !/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/.test(value)) {
        callback(new Error('请输入正确的URL格式'))
      } else {
        callback()
      }
    }
    
    return {
      loading: false,
      saveLoading: false,
      settingsForm: {
        usdt: '',
        erc: '',
        tokenPaySecret: '',
        tokenPayService: '',
        notifyUrl: '',
        telegram: '',
        email: ''
      },
      rules: {
        usdt: [
          { required: true, message: '请输入USDT密钥', trigger: 'blur' }
        ],
        erc: [
          { required: true, message: '请输入ERC密钥', trigger: 'blur' }
        ],
        tokenPaySecret: [
          { required: true, message: '请输入TokenPay密钥', trigger: 'blur' }
        ],
        tokenPayService: [
          { required: true, message: '请输入TokenPay服务地址', trigger: 'blur' },
          { validator: validateUrl, trigger: 'blur' }
        ],
        notifyUrl: [
          { required: true, message: '请输入回调地址', trigger: 'blur' },
          { validator: validateUrl, trigger: 'blur' }
        ],
        telegram: [
          { required: true, message: '请输入客服联系方式', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱联系方式', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 获取系统设置
    fetchSettings() {
      this.loading = true
      
      axios.get('/system/settings')
        .then(response => {
          this.loading = false
          
          if (response.data.status === 200) {
            const { data } = response.data
            // 更新表单数据
            this.settingsForm = {
              usdt: data.usdt || '',
              erc: data.erc || '',
              tokenPaySecret: data.tokenPaySecret || '',
              tokenPayService: data.tokenPayService || '',
              notifyUrl: data.notifyUrl || '',
              telegram: data.telegram || '',
              email: data.email || ''
            }
          } else {
            this.$message.error(response.data.message || '获取系统设置失败')
          }
        })
        .catch(error => {
          this.loading = false
          const errorMsg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '网络错误，请稍后重试'
          this.$message.error(errorMsg)
          console.error('获取系统设置失败:', error)
        })
    },
    
    // 保存系统设置
    saveSettings() {
      this.$refs.settingsForm.validate(valid => {
        if (valid) {
          this.saveLoading = true
          
          axios.post('/system/settings/update', this.settingsForm)
            .then(response => {
              this.saveLoading = false
              
              if (response.data.status === 200) {
                this.$message.success('保存成功')
              } else {
                this.$message.error(response.data.message || '保存失败')
              }
            })
            .catch(error => {
              this.saveLoading = false
              const errorMsg = error.response && error.response.data && error.response.data.message
                ? error.response.data.message
                : '网络错误，请稍后重试'
              this.$message.error(errorMsg)
              console.error('保存系统设置失败:', error)
            })
        }
      })
    },
    
    // 重置表单
    resetForm() {
      this.$refs.settingsForm.resetFields()
      this.fetchSettings() // 重新获取原始数据
    }
  },
  created() {
    console.log('Settings component created')
    this.fetchSettings()
  }
}
</script>

<style scoped>
.settings-container {
  padding: 20px;
}

.el-divider {
  margin: 20px 0;
}

.el-form-item {
  max-width: 600px;
}
</style> 